import * as React from 'react';

import { use$ } from '@legendapp/state/react';
import { CTA, styled } from '@volkswagen-onehub/components-core';
import { EnterFullscreen, ExitFullscreen } from '@volkswagen-onehub/icons-core';

import { fullscreenStore, toggleFullscreenHandler } from '../../store';
import { testId } from '../../test-utils/constants';

export function FullscreenButton() {
	const isFullscreenMode = use$(fullscreenStore.isFullscreenMode);

	const Icon = isFullscreenMode ? ExitFullscreen : EnterFullscreen;

	return (
		<StyledCTA
			data-testid={testId('Fullscreen_Button')}
			emphasis="tertiary"
			tag="button"
			onClick={toggleFullscreenHandler}
			icon={<Icon aria-label="EnterFullscrenn" />}
		/>
	);
}

const StyledCTA = styled(CTA)`
	flex-shrink: 0;

	&& {
		color: #293043;
		opacity: 1;
	}

	&& svg,
	&& svg [stroke] {
		color: #293043;
	}
`;
